import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lib-form-link',
  styleUrls: ['form-link.component.scss'],
  templateUrl: './form-link.component.html',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
})
export class FormLinkComponent extends FieldBaseComponent {}
